// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3AkP0","obliqueLineWrap":"membershipbadge_obliqueLineWrap__JuHN6","obliqueLine":"membershipbadge_obliqueLine__1A4yg"};